module.exports = __webpack_public_path__ + "img/slider_2.57bef760.jpg";